// extracted by mini-css-extract-plugin
export var chatHtmlText = "_m4-2";
export var chatLink = "_m4-0";
export var chatText = "_m4-1";